import axios from '_u/axios'

// 客户接待详情
export const receptionDetailed = (body) => {
    return axios.post('customer/reception/detailed', body)
}

// 新增客户接待
export const receptionAdd = (body) => {
    return axios.post('customer/reception/add', body)
}

// 修改客户接待
export const receptionUpdate = (body) => {
    return axios.post('customer/reception/update', body)
}